define('UrlFactory',['site_vars','string'],function(site_vars,S){

    // Object de portée globale pour fabriquer les URL

    var app,router,
        domain_sharding_img = site_vars.domain_sharding_img;

    // pour ne pas utiliser de domain sharding, laisser vide la configuration _DOMAIN_SHARDING_IMG_
    if(domain_sharding_img && domain_sharding_img.length > 0){
        domain_sharding_img = domain_sharding_img.split(',');
    }else{
        domain_sharding_img = false;
    }

    function getDomainShardingImgUrl(path){
        var base_url = site_vars.base_url;
        if(domain_sharding_img){
            var h=0, l =domain_sharding_img.length, index=0;
            if(l>1){
                // si on utilise plusieurs sous-domaine
                // on utilise le chemin pour obtenir l'index du sous-domaine
                for(var i=0; i<path.length; i++){
                    h += path.charCodeAt(i);
                }
                index = h%l;
            }
            // on obtient le sous-domaine
            base_url = site_vars.http_mode+'://'+domain_sharding_img[index]+'/';
        }
        return base_url+path;
    }

    var UrlFactory = {
        // retourne l’url complete
        getUrl:function(route,options,ignoreBaseUrl,ignoreLang){
            if(!options){
                options = {};
            }
            options.c = app.c;
            return UrlFactory.getUrlTemplate(route,ignoreBaseUrl,ignoreLang)(options);
        },
        // retourne la route
        getRoute:function(route,options,ignoreBaseUrl,ignoreLang){
            if(_.isUndefined(ignoreBaseUrl)) ignoreBaseUrl = true;
            if(_.isUndefined(ignoreLang)) ignoreLang = true;
            return UrlFactory.getUrl(route,options,ignoreBaseUrl,ignoreLang);
        },
        getUrlTemplate:function(route,ignoreBaseUrl,ignoreLang){
            return router.getRouteUrl(route,ignoreBaseUrl,ignoreLang);
        },
        getUrlPicture:function(id_picture, type, format, rewrite, extension){
            var path = type+"-"+id_picture + '-' + format + "/" + S(rewrite).slugify().s + '.' + extension.toLowerCase();
            return getDomainShardingImgUrl(path);
        },
        getDomainShardingImgUrl:getDomainShardingImgUrl,
        getUrlVideo:function(id_video, size, type, format){
            // size : 240p | 480p | 720p | 1080p
            // type : full | standard
            // format : mp4 | ogv | webm | png
            if(!size){
                size = '1080p';
            }
            if(!type){
                type = 'full';
            }
            if(!format){
                format = 'mp4';
            }
            return UrlFactory.getUrl('video',{id_video:id_video,size:size,type:type,format:format});
        },
        getThemeUrl: function(){
            return site_vars.theme_url;
        },
        getBaseUrl:function(){
            return site_vars.base_url;
        },
        getUrlParam:function(name){
            var param, results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href);
            if (results==null){
                param = null;
            }
            else{
                param = results[1] || 0;
            }
            return param;
        }
    }
    // Global scope
    window.UrlFactory = UrlFactory;
    UrlFactory.setup = function(appModel,routerModel){
        app = appModel;
        router = routerModel;
    };
    return UrlFactory;
});
